import { Link } from 'react-router-dom';
import { Button, ButtonProps, IconButton } from '@mui/material';

//
//

type AppButtonProps = ButtonProps & {
  to?: string;
  href?: string;
  target?: string;
};

export const AppButton: React.FC<AppButtonProps> = ({ children, to, href, target, disabled, ...props }) => {
  return (
    <Button
      component={to ? Link : href ? 'a' : 'button'}
      size={props?.size || 'small'}
      to={to}
      href={href}
      target={target}
      disabled={!!disabled}
      {...props}
    >
      {children}
    </Button>
  );
};

//
//

type AppIconButtonProps = Omit<ButtonProps, 'variant' | 'color'> & {
  to?: string;
  href?: string;
  target?: string;
};

export const AppIconButton: React.FC<AppIconButtonProps> = ({ children, to, href, target, ...props }) => {
  return (
    <IconButton
      component={to ? Link : href ? 'a' : 'button'}
      size={props?.size || 'small'}
      to={to}
      href={href}
      target={target}
      {...props}
    >
      {children}
    </IconButton>
  );
};
